import axios from 'axios';
import { apiUrl } from '../../api/endpoints';

export const fetchTemplateExamples = async () => {
    const res = await axios.get(apiUrl(`template/examples/list`));
    if (res.data?.status !== 'OK' || !Array.isArray(res.data.data)) {
        throw new Error('Invalid template examples response.');
    }

    return res.data.data;
};

export const createTemplateExampleFromTemplate = async (templateId, exampleName) => {
    const res = await axios.post(
        apiUrl(`template/examples/from-template/${templateId}`),
        { example_name: exampleName },
        { headers: { 'Content-Type': 'application/json' } }
    );

    if (res.status !== 201 || res.data?.status !== 'OK') {
        throw new Error('Received an unexpected response from the server.');
    }

    return res;
};

export const attachTemplateExampleToTemplate = async (templateId, templateExampleId, unexpectedResponseMessage) => {
    const res = await axios.put(
        apiUrl(`template/attach-example/${templateId}`),
        { template_example_id: templateExampleId },
        { headers: { 'Content-Type': 'application/json' } }
    );

    if (res.status !== 200 || res.data?.status !== 'OK' || !res.data?.data) {
        throw new Error(unexpectedResponseMessage || 'Received an unexpected response from the server.');
    }

    return res;
};

export const detachTemplateExampleFromTemplate = async (templateId, unexpectedResponseMessage) => {
    const res = await axios.put(
        apiUrl(`template/detach-example/${templateId}`),
        {},
        { headers: { 'Content-Type': 'application/json' } }
    );

    if (res.status !== 200 || res.data?.status !== 'OK') {
        throw new Error(unexpectedResponseMessage || 'Received an unexpected response from the server.');
    }

    return res;
};
